import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InformationDialogDto } from '@modules/shell/services/information-dialog.service';

@Component({
  selector: 'app-information-dialog',
  templateUrl: './information-dialog.component.html',
  styleUrls: ['./information-dialog.component.scss'],
})
export class InformationDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: InformationDialogDto) {}

  ngOnInit(): void {}
}
